import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M2_StorageClasses = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Storage Classes and Scope and Lifetime of a Variable"
    videos={[
      "https://www.youtube.com/embed/YNHke7kVy_s", // Storage class and scope explanation
      "https://www.youtube.com/embed/5SI00Ix5q6w", // Storage classes: static, auto, extern, register
    ]}
    takeaways={[
      { text: "This is mostly theory-based, so thoroughly learn the concepts." },
      { text: "Understand the differences between various storage classes in C." },
      { text: "Have a clear understanding of the scope and lifetime of variables." },
    ]}
    questions={[
      "Explain the differences between auto, static, extern, and register storage classes.",
      "Given a code snippet, identify the value of variables in different blocks considering their scope and lifetime.",
      "Define storage classes and explain their significance in C.",
      "What is the difference between scope and lifetime of a variable?",
    ]}
    exampleVideos={[]} // No extra example videos for now
  />
);
}

export default OOPS_M2_StorageClasses;
